// CANONICAL COPY (GH #7115). src/constants/obligations/obl-config-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-config-management',
  title: 'Review configuration management process',
  description:
    'Verify that secure configurations for hardware, software, and network devices are established, documented, and reviewed.',
  category: 'technical',
  scfIds: ['SCF-OPS-005'],
  cadence: { frequency: '6m', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Configuration management procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is current' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
